export default "__VITE_ASSET__DXmtAD3n__"